window._ = require('lodash');
window.moment = require('moment');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Set locale.
 */
const lang = document.documentElement.lang;
if (lang) {
    // Set 'Accept-Language' header for all AJAX requests.
    window.axios.defaults.headers.common['Accept-Language'] = lang;

    // Configure 'moment'-locale.
    moment.locale(lang);
} else {
    console.error('Document language is not defined.');
}

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

/**
 * Initialize page content scripts.
 */
// import {hideNavbarOnScroll} from './modules/navbar-controls'
// hideNavbarOnScroll('.navbar', 10, 200, 'fixed-top', '--hidden', '#main-nav');

/**
 * Format all dates on page.
 */
import * as dateTimeFormatters from './modules/date-time-formatting'

(function (selectionClass, notFormattedClass) {
    function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    function removeClass(el, className) {
        const regExp = new RegExp('\\b' + className + '\\b', 'g');
        el.className = el.className.replace(regExp, '');
    }

    const elements = document.getElementsByClassName(
        selectionClass + ' ' + notFormattedClass);
    for (let i = 0, el, funcName, args; i < elements.length; i++) {
        el = elements[i];
        funcName = 'format' + capitalizeFirstLetter(el.dataset.formatter);
        args = el.textContent.trim().split('|').map(arg => arg.trim());
        args.push(el.dataset.format);

        // Apply formatting function.
        el.textContent = dateTimeFormatters[funcName].apply(dateTimeFormatters, args);

        removeClass(el, notFormattedClass);
    }
})('js-date-time-format', 'not-formatted');

/**
 * Render page content with Vue.
 */
import Vue from 'vue'

window.Vue = Vue;

// Define global translations object if not defined.
if (typeof window.translations !== 'object') {
    window.translations = {}
}

/**
 * A helper function for extending the translations data object.
 * @param {Object} data
 */
window.extendTranslations = function (data) {
    Object.assign(this.translations, data)
};

// Register Vue plugins.
import VueTranslationPlugin from './modules/vue-translation-plugin'
import VueMomentFormatPlugin from './modules/vue-moment-format-plugin'

Vue.use(VueTranslationPlugin, window.translations);
Vue.use(VueMomentFormatPlugin);

// Define global components (that may appear in the page content).
Vue.component('music-albums', require('./components/MusicAlbums.vue'));
Vue.component('shows-list', require('./components/ShowsList.vue'));
Vue.component('news-list', require('./components/NewsList.vue'));
Vue.component('photo-gallery', require('./components/PhotoGallery.vue'));
Vue.component('video-gallery', require('./components/VideoGallery.vue'));

// Render page content as Vue instance (will initialize embed components if any).
new Vue({
    el: '#page-content'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js